<template>
  <div style="padding: 20px">
    <el-button type="primary" @click="login">登录</el-button>
    <span v-if="token" style="margin-left: 10px">登录成功，登录信息是：{{ token }}</span>

    <div v-if="token" style="margin-top: 20px">
      <el-button type="success" @click="downloadTemplate">下载excel模板</el-button>

      <el-upload
        class="upload-demo"
        drag
        action=""
        :before-upload="handleUpload"
        :show-file-list="false"
        style="margin-top: 20px"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传excel模板</em></div>
      </el-upload>

      <el-button type="danger" style="margin-top: 20px" @click="execute">一键执行</el-button>

      <el-table :data="uploadedData" border style="margin-top: 20px" v-if="uploadedData.length">
        <el-table-column prop="pid" label="PID" />
        <el-table-column prop="access_token" label="Access Token" />
        <el-table-column prop="manager_id" label="管家账户ID" />
        <el-table-column prop="account_id" label="投放账户ID" />
        <el-table-column prop="source_id" label="数据源ID" />
        <el-table-column prop="package_name" label="包名" />
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as XLSX from 'xlsx'

export default {
  data() {
    return {
      token: '',
      uploadedData: []
    }
  },
  methods: {
    async login() {
      const logid = 'BT_' + Date.now()
      try {
        const response = await axios.post(
          `smapi/api/login?logid=${logid}`,
          {
            name: 'zhiwei-vivo',
            password: 'zhiwei-1020.BTX'
          },
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              'Origin': 'https://growth.tianjinzhaofa.cn',
              'Referer': 'https://growth.tianjinzhaofa.cn/login',
              'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:139.0) Gecko/20100101 Firefox/139.0',
              'Accept': 'application/json, text/plain, */*'
            }
          }
        )
        if (response.data.code === 0) {
          this.token = response.data.body.token
        }
      } catch (e) {
        console.error('登录失败', e)
      }
    },
    downloadTemplate() {
      const ws = XLSX.utils.aoa_to_sheet([
        ['PID', 'access_token', '管家账户ID', '投放账户ID', '数据源ID', '包名'],
        ['', '', '', '', '', '']
      ])
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Template')
      XLSX.writeFile(wb, 'template.xlsx')
    },
    handleUpload(file) {
      const reader = new FileReader()
      reader.onload = e => {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const sheetName = workbook.SheetNames[0]
        const sheet = workbook.Sheets[sheetName]
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 })

        const headers = jsonData[0]
        const rows = jsonData.slice(1)

        const map = {
          'PID': 'pid',
          'access_token': 'access_token',
          '管家账户ID': 'manager_id',
          '投放账户ID': 'account_id',
          '数据源ID': 'source_id',
          '包名': 'package_name'
        }

        const result = rows.map(row => {
          const obj = {}
          headers.forEach((header, idx) => {
            const key = map[header]
            if (key) obj[key] = row[idx] || ''
          })
          return obj
        }).filter(item => item.pid && item.pid.trim() !== '')


        this.uploadedData = result
        console.log(this.uploadedData)
      }
      reader.readAsArrayBuffer(file)
      return false // 阻止默认上传行为
    },
    async execute() {
      console.log(this.uploadedData)
      for (const row of this.uploadedData) {
        const logid = () => 'BT_' + Date.now()
        const headers = {
          'Content-Type': 'application/json; charset=UTF-8',
          'Origin': 'https://growth.tianjinzhaofa.cn',
          'Referer': 'https://growth.tianjinzhaofa.cn/launch/external-channel',
          'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:139.0) Gecko/20100101 Firefox/139.0',
          'Accept': 'application/json, text/plain, */*',
          'Authorization': 'Bearer ' + this.token
        }

        try {
          const infoRes = await axios.post(
            'smapi/api/project_agent/index?logid=' + logid(),
            {
              pid: row.pid,
              current: 1,
              pageSize: 50,
              total: 2941
            },
            { headers }
          )

          let project = null
          if (
            infoRes &&
            infoRes.data &&
            infoRes.data.body &&
            infoRes.data.body.list &&
            infoRes.data.body.list.length > 0
          ) {
            project = infoRes.data.body.list[0]
          }

          if (!project) {
            console.warn('未获取到项目信息: ' + row.pid)
            continue
          }

          await axios.post(
            'smapi/api/project_agent/edit?logid=' + logid(),
            {
              conversion_access_token: String(row.access_token), // 转换为字符串
              authorized_account_id: String(row.manager_id),
              conversion_advertiser_id: row.account_id,
              conversion_src_id: row.source_id,
              conversion_page_url: project.conversion_page_url,
              id: project.id
            },
            { headers }
          )

          const finalRes =     await axios.post(
            'smapi/api/commissions/vivo?logid=' + logid(),
            {
              pkg: row.package_name,
              pid: row.pid,
              clickid: 'RequestId_111111111111122',
              adid: 'CreativeId_0000000000000',
              brand: 'vivo'
            },
            {
              headers: Object.assign({}, headers, {
                Referer: 'https://growth.tianjinzhaofa.cn/launch/tools'
              })
            }
          )
          if (finalRes.data && finalRes.data.body && finalRes.data.body.code === 200) {
            this.$message.success('✅ 执行完成: ' + row.pid);
          } else {
            this.$message.error('请求成功但返回非预期:' + row.pid);
            console.log(`请求成功但返回非预期: ${row.pid}`);
          }

        } catch (error) {
          this.$message.error('请求失败:' + row.pid);
        }
      }
    }
  }
}
</script>

<style scoped>
.upload-demo {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  background-color: #f5f7fa;
  text-align: center;
  padding: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/login/smqudao.vue